import InvestAddOnFlow from './flows/InvestAddOnFlow';
import RetireAddOnFlow from './flows/RetireAddOnFlow';
import DebitSignUpFlow from './flows/DebitSignUpFlow';

// prettier-ignore
export const productToFlow = {
	'invest-add-on': InvestAddOnFlow,
	'retire-add-on': RetireAddOnFlow,
	'debit': DebitSignUpFlow
};

export const SignUpFlow = {
	getFlow: (product) => {
		return productToFlow[product];
	},
};

export default SignUpFlow;
